var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"editor pa-0 ma-0",attrs:{"disabled":_vm.editorDisabled,"elevation":"0"}},[_c('v-text-field',{attrs:{"color":"success","label":"Main input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }